<template>

    <div>
        
        <p id="maintenance" v-bind:style="enabled ? 'display:none' : 'display:block'">
            Our calculator is being updated. We apologize for the inconvenience.
        </p>


        <div id="calculator"  v-bind:style="
                                showDebug ? 'max-width: none' : 'max-width: 1260px',
                                enabled ? 'display:block' : 'display:none'">

            <h1>Generator sizing calculator</h1>
            <hr style="margin-bottom: 30px">

            <div class="application-setup">
                <div class="left" >
                    <label>Application Voltage</label>
                    <v-select  :reduce="item => item.key" v-model="appVoltage" :options="voltages" :clearable="false" :searchable="false" class="header-select"
                            v-tooltip="'Select the voltage for this application from the drop down menu'"></v-select>
                </div>

                <div class="right">
                    <label>Maximum Allowable Voltage Dip</label>
                    <v-select  :reduce="item => item.key" v-model="appVoltageDip" :options="voltageDips" :clearable="false" :searchable="false" class="header-select"
                            v-tooltip="'Select the maximum allowable voltage dip for this application from the drop down menu. If a maximum voltage dip is not specified, select 35% voltage dip.'"
                    ></v-select>
                </div>
            </div>


            <div class="table-container">
                <table>
                    <thead>
                    <tr>
                        <th v-show="showDebug">Load Description</th>
                        <th>Start Sequence</th>
                        <th>Motor HP</th>
                        <th>NEMA Motor Code</th>
                        <th v-show="showDebug">SkVA / HP</th>
                        <th style="min-width: 185px">Motor Starter Type</th>
                        <th v-show="showDebug">Adjusted SkVA / HP</th>
                        <th colspan="2" style="border-right: none">Running Power Factor</th>
                        <th v-show="showDebug">Running Amps</th>
                        <th v-show="showDebug">Running KW</th>
                        <th v-show="showDebug">Running kVA</th>
                        <th v-show="showDebug">Starting KVA</th>
                        <th v-show="showDebug"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <template v-for="(item, idx) in load">
                        <tr>
                            <td v-show="showDebug" ><input v-bind:value="item.description" /></td>
                            <td v-tooltip="'The order in which this load will start'">
                                <v-select v-model="item.start" :options="startOptions()" class="table-select" :clearable="false" :searchable="false" ></v-select>
                            </td>
                            <td v-tooltip="'Select the motor horsepower from the drop down menu.'">
                                <v-select v-model="item.hp"  :reduce="item => item.value" :options="hp" class="table-select" :clearable="false" :searchable="false" ></v-select>
                            </td>
                            <td v-tooltip="'Select NEMA Motor Code from the dropdown list. If data is unavailable, assume code G.'">
                                <v-select label="key" :reduce="item => item.key" v-model="item.code" :options="motorGroups" class="table-select" :clearable="false" :searchable="false" ></v-select>
                            </td>
                            <td v-show="showDebug">{{ sKVAOverHP(item.code) }}</td>
                            <td v-tooltip="'Select motor starter type. If starter type is unknown, assume Across the line.'">
                                <v-select label="value" :reduce="item => item.key" v-model="item.starter" :options="starter" class="table-select" :clearable="false" :searchable="false" ></v-select>

                            </td>
                            <td v-show="showDebug">{{ adjustedSKVAOverHP(item.starter, item.code) }}</td>
                            <td v-tooltip="'Input running power factor from motor dataplate. If data is unavailable enter 0.8.'">
                                <v-select v-model="item.factor" :options="[0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]" class="table-select" :clearable="false" :searchable="false" ></v-select>
                            </td>
                            <td v-show="showDebug">{{ phase(item.hp) }}</td>
                            <td v-show="showDebug">{{ runningKW(phase(item.hp), item.factor) }}</td>
                            <td v-show="showDebug">{{ runningKVA(phase(item.hp)) }}</td>
                            <td v-show="showDebug">{{ startingKVA(item) }}</td>
                            <td style="text-align: right"><a href="#" v-on:click="deleteItem(idx)" class="lightblue"> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAABHNCSVQICAgIfAhkiAAAALJJREFUKFOFkeEVwUAQhL+pBJVIKkAHOvBUQDqgAkqgAlKJp5L1JpK4EMn+unv77dzMniIiA4JP3ZOze20pIlIw7f2cDXemh2jDfnY+KPluloYPwAbIBwZuwNHwHthJ0j+4zlW0sJUlpZuoZutMVt42AX0Zg/MUXkm6fFuJiDVwqsQiYgo8gEKS/XeqyQTMqlBtgAHYC0jhq6Rlj7KtLVLYW5gA55712fNTUtYoj/1iafgFeAxhT7dH/ZcAAAAASUVORK5CYII="> </a></td>
                        </tr>
                    </template>
                    <tr v-show="showDebug">
                        <td colspan="8">Total Running Load</td>
                        <td>{{ totalPhase() }}</td>
                        <td>{{ totalRunningKW() }}</td>
                        <td>{{ totalRunningKVA() }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="add-row">
                <a href="#" v-on:click="addItem" class="lightblue" style="text-decoration: none">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABHNCSVQICAgIfAhkiAAAACxJREFUKFNjZMACIva8/g8SXuEiyogujSEAUjDUNMDci83z2MQYSdYwEoMVAGShLgnU64XbAAAAAElFTkSuQmCC" style="margin-right: 5px">Add Row</a>
            </div>

            <table v-show="showDebug">
                <tr>
                    <th colspan="3">Starting Impact (SkVA)</th>
                </tr>
                <tr v-for="(item, index) in load">
                    <td colspan="2">Sequence {{index + 1}}</td>
                    <td>{{impact(index)}}</td>
                </tr>
                <tr>
                    <td colspan="2">Sequence {{load.length + 1}}</td>
                    <td>{{impact(load.length)}}</td>
                </tr>
                <tr>
                    <td colspan="2">Maximum Impact</td>
                    <td>{{this.maximumImpact()}}</td>
                </tr>
            </table>

            <div class="doosan-recommends"  v-show="!showHelp && this.load.length > 0" >
                <span class="recommends-1">Doosan recommends model</span>
                <span class="recommends-2">{{model()}}</span>
                <span class="recommends-3">for this application</span>
            </div>
            <div class="doosan-recommends"  v-show="showHelp" >
                <span class="recommends-3">This load requires paralleling - call your local Doosan Dealer for assistance.</span>
            </div>
            <div class="table-container" v-show="this.load.length > 0">

            <table>
            <thead>

            <tr>
                    <th></th>
                    <th>Amperage</th>
                    <th>kW</th>
                    <th>kVA</th>
                    <th>SkVA</th>
                </tr>
            </thead>
            <tbody>

                <tr>
                    <td>Machine Rating</td>
                    <td style="text-align: center">{{modelSpecifications('amps')}}</td>
                    <td style="text-align: center">{{modelSpecifications('kw')}}</td>
                    <td style="text-align: center">{{modelSpecifications('kVA')}}</td>
                    <td style="text-align: center">{{modelSpecifications('select')}}</td>
                </tr>
                <tr>
                    <td>Application</td>
                    <td style="text-align: center">{{totalPhase()}}</td>
                    <td style="text-align: center">{{totalRunningKW()}}</td>
                    <td style="text-align: center">{{totalRunningKVA()}}</td>
                    <td style="text-align: center">{{maximumImpact()}}</td>
                </tr>
                <tr>
                    <td>% Load</td>
                    <td style="text-align: center">{{ Math.round(totalPhase()      / modelSpecifications('amps')   * 100) }}%</td>
                    <td style="text-align: center">{{ Math.round(totalRunningKW()  / modelSpecifications('kw')     * 100) }}%</td>
                    <td style="text-align: center">{{ Math.round(totalRunningKVA() / modelSpecifications('kVA')    * 100) }}%</td>
                    <td style="text-align: center">{{ Math.round(maximumImpact()   / modelSpecifications('select') * 100) }}%</td>
                </tr>
            </tbody>
            </table>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data(){
            return  {
                enabled: false,
                showDebug: false,
                appVoltage: '460-3',
                appVoltageDip: 35,
                voltages: [
                   // { key: '115-1', label: '115V-1Ø', value: 115 },
                   // { key: '230-1', label: '230V-1Ø', value: 230 },
                   // { key: '200-3', label: '200V-3Ø', value: 200 },
                    { key: '230-3', label: '230V-3Ø', value: 230 },
                    //{ key: '380-3', label: '380V-3Ø', value: 380 },
                    { key: '460-3', label: '460V-3Ø', value: 460 },
                    //{ key: '575-3', label: '575V-3Ø', value: 575 },
                ],
                voltageDips: [
                    { key: 20, label: '20% Voltage Dip' },
                    { key: 25, label: '25% Voltage Dip' },
                    { key: 30, label: '30% Voltage Dip' },
                    { key: 35, label: '35% Voltage Dip' },
                ],
                hp: [
                    { label: '1/6', value: 1/6 },
                    { label: '1/4', value: 1/4 },
                    { label: '1/3', value: 1/3 },
                    { label: '1/2', value: 1/2 },
                    { label: '3/4', value: 3/4 },
                    { label: '1', value: 1 },
                    { label: '1.5', value: 1.5 },
                    { label: '2', value: 2 },
                    { label: '3', value: 3 },
                    { label: '5', value: 5 },
                    { label: '7.5', value: 7.5 },
                    { label: '10', value: 10 },
                    { label: '15', value: 15 },
                    { label: '20', value: 20 },
                    { label: '25', value: 25 },
                    { label: '40', value: 40 },
                    { label: '50', value: 50 },
                    { label: '60', value: 60 },
                    { label: '75', value: 75 },
                    { label: '100', value: 100 },
                    { label: '125', value: 125 },
                    { label: '150', value: 150 },
                    { label: '175', value: 175 },
                    { label: '200', value: 200 },
                    { label: '250', value: 250 },
                    { label: '300', value: 300 },
                    { label: '350', value: 350 },
                    { label: '400', value: 400 },
                    { label: '450', value: 450 },
                    { label: '500', value: 500 }
                ],
                motorGroups: [
                    { key: 'A', value: 1.57 },
                    { key: 'B', value: 3.345 },
                    { key: 'C', value: 3.77 },
                    { key: 'D', value: 4.245 },
                    { key: 'E', value: 4.745 },
                    { key: 'F', value: 5.295 },
                    { key: 'G', value: 5.945 },
                    { key: 'H', value: 6.695 },
                    { key: 'J', value: 7.545 },
                    { key: 'K', value: 8.495 },
                    { key: 'L', value: 9.495 },
                    { key: 'M', value: 10.595 },
                    { key: 'N', value: 11.845 },
                    { key: 'P', value: 13.245 },
                    { key: 'R', value: 14.995 },
                    { key: 'S', value: 16.995 },
                    { key: 'T', value: 18.995 },
                    { key: 'U', value: 21.195 }
                ],
                starter: [
                    { key: 'accross-the-line', value:'Accross the line' },
                    { key: 'soft-start', value:'Soft start' },
                    { key: 'at-50-tap', value:'Auto-transformer 50% tap' },
                    { key: 'at-65-tap', value:'Auto-transformer 65% tap' },
                    { key: 'at-80-tap', value:'Auto-transformer 80% tap' },
                    { key: 'reactor-80-tap', value:'Reactor 80% Tap'  },
                    { key: 'part-winding-starter', value:'Part-Winding Starter' },
                ],
                voltage: '230-1',
                showHelp: false,
                maximumDip: 30,
                load: [
                    {
                        description: 'Water Room',
                        start: 1,
                        hp: 15,
                        code: 'G',
                        starter: 'accross-the-line',
                        factor: 0.8
                    },
                    {
                        description: 'North Facility',
                        start: 2,
                        hp: 15,
                        code: 'G',
                        starter: 'accross-the-line',
                        factor: 0.8,
                    },
                ],
            }
        },
        methods: {
                addItem: function () {
                    this.load.push({
                        start: this.load.length + 1,
                        factor: 0.8,
                        hp: 10,
                        code: 'G',
                        starter: 'accross-the-line'
                    });
                },
                deleteItem: function (idx) {
                    this.load.splice(idx, 1);
                },
                adjustedSKVAOverHP: function (starter, code) {
                    return adjustedSKVAOverHP(starter, code);
                },
                appVoltageValue: function() {
                    return parseInt(this.appVoltage.substring(0,3));
                },
                phase: function (hp) {
                    return phase(hp, this.appVoltage);
                },
                runningKW: function (phase, factor) {
                    return runningKW(this.appVoltageValue(), phase, factor);
                },
                runningKVA: function (phase){
                    return runningKVA(this.appVoltageValue(), phase);
                },
                sKVAOverHP: function (code) {
                    return sKVAOverHP(code);
                },
                startingKVA: function (item) {
                    return sKVA(item.hp, item.code, item.starter);
                },
                totalPhase: function () {
                    return this.load.reduce((carry, item) => carry + this.phase(item.hp), 0)
                },
                totalRunningKW: function () {
                    return this.load.reduce((carry, item) => carry + this.runningKW(this.phase(item.hp), item.factor), 0)
                },
                totalRunningKVA: function () {
                    return this.load.reduce((carry, item) => carry + this.runningKVA(this.phase(item.hp)), 0)
                },
                totalStartingKVA: function () {
                    return this.load.reduce((carry, item) => carry + this.startingKVA(item), 0)
                },
                carryRunningKVA: function (start) {
                    let sum = 0;
                    for(let i = 0; i <this.load.length; i++){
                        let item = this.load[i];
                        if(item.start < start) {
                          sum += this.runningKVA(this.phase(item.hp));
                        }
                    }
                    return sum;
                },
                carryStartingKVA: function (start) {
                    let sum = 0;
                    for(let i = 0; i < this.load.length; i++){
                        let item = this.load[i];
                        if(item.start === start){
                          sum += this.startingKVA(item);
                        }
                    }
                    return sum;
                },
                impact: function (seq, log) {
                    let sequenceSKVA = (seq < this.load.length) ? this.carryStartingKVA(seq+1) : 0;
                    let carryRunningKVA = 0;
                    if(seq < this.load.length && seq !== 0) carryRunningKVA = this.carryRunningKVA(seq+1);
                    if(log){
                      console.log(seq, '= ', sequenceSKVA, 'starting         + ', carryRunningKVA, '   already running');
                    }
                    return sequenceSKVA + carryRunningKVA;
                },
                maximumImpact: function () {
                    let max = -1;
                    for (let i = 0; i < this.load.length; i++){
                        if(this.impact(i) > max) max = this.impact(i);
                    }
                    return max;
                },
                model: function () {
                    let amp = this.totalPhase();
                    let kw = this.totalRunningKW();
                    let kva = this.totalRunningKVA();
                    let imp = this.maximumImpact();
                    return model(amp, kw, kva, imp, this.appVoltageDip, this.appVoltageValue());
                },
                modelSpecifications: function(param){
                    try{
                        let $model = this.model();
                        let $voltage = this.appVoltageValue();
                        let ms = modelSpecifications[$voltage][$model][param];
                        this.showHelp = false;
                        return ms;
                    }catch(e){
                        console.log(e)
                        this.showHelp = true;
                    }

                },
                startOptions: function () {
                  let arr = [...Array(this.load.length + 1).keys()];
                  arr.shift();
                  return arr;
                }
        },
    }
</script>
<style>
    @font-face {
        font-family: 'Blender-Pro';
        src: url("../assets/Blender-Pro-Medium.otf") format("opentype")
    }

    body{
        background-color: #092632;
    }

    #maintenance {
        display: flex !important;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 2rem;
        font-family: 'Blender-Pro';
        height: 100vh;
    }

    #calculator {
        padding: 30px;
        margin: auto;
        box-sizing: border-box;
    }

    #calculator > .table-container {
        max-width: 100%;
    }

    #calculator > .table-container > table {
        min-width: 964px;
    }

    #calculator, #calculator > .table-container > table {
        font-family: 'Blender-Pro';
        color: #fff;
        background-color: #092632;
        text-transform: uppercase;
        letter-spacing: 0.2em;
        /*table-layout: fixed;*/
        width: 100%;
    }

    #calculator > .table-container > table > thead > tr > th {
        font-size: 0.8em;
        font-weight: initial;
        opacity: .71;
        text-align: center;
        background-color: #223c46;
        padding: 15px;
        width: 20%;
        border-right: 3px solid #092632;
    }

    #calculator > .table-container > table > tbody > tr > td {
        text-align: left;
        padding-left: 15px;
        width: 20%;
    }

    #calculator h1 {
        text-transform: uppercase;
        text-align: center;
        font-size: 25px;
        font-weight: 100;
    }

    #calculator hr {
        border: 1px solid #58BCEB;
        border-bottom: none;
        border-left: none;
        border-right: none;
    }

    #calculator label {
        opacity: .71;
        margin-bottom: 5px;
        display: inline-block;
    }

    #calculator .application-setup {
        display: flex;
        margin-bottom: 30px;
    }


    #calculator .application-setup div.left  {
        width: calc(50% - 10px);
        padding-right: 10px;
    }

    #calculator .application-setup div.right {
        width: 50%;
    }

    #calculator .application-setup > * {
        flex: 0 0 auto;
    }


    #calculator .application-setup select{
        width: 98%;
        padding-right: 20px
    }

    #calculator .add-row {
        text-align: right;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    #calculator .doosan-recommends {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding: 50px;
        text-align: center;
    }

    #calculator .doosan-recommends .recommends-1 {
        font-size: 25px;
        margin-bottom: 10px;
    }

    #calculator .doosan-recommends .recommends-2 {
        color: black;
        background-color: #58bceb;
        font-size: 34px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 55px;
        padding-right: 55px;
        font-weight: bold;
        margin-bottom: 10px

    }

    #calculator .doosan-recommends .recommends-3 {
        font-size: 19px;
        opacity: .71;
    }

    .lightblue {
        color: #58BCEB;
    }

    /***************************************
     Doosan Recommends border effect
    ****************************************/

    #calculator .doosan-recommends:before,
    #calculator .doosan-recommends:after,
    #calculator .doosan-recommends>:last-child:before,
    #calculator .doosan-recommends>:last-child:after {
        position: absolute;
        width: 15px;
        height: 15px;
        border-color: rgba(255, 255, 255, .71);
        border-style: solid;
        content: ' ';
    }

    #calculator .doosan-recommends:before {
        top: 10px;
        left: 0px;
        border-width: 1px 0 0 1px
    }

    #calculator .doosan-recommends:after {
        top: 10px;
        right: 0px;
        border-width: 1px 1px 0 0
    }

    #calculator .doosan-recommends>:last-child:before {
        bottom: 10px;
        right: 0px;
        border-width: 0 1px 1px 0
    }

    #calculator .doosan-recommends>:last-child:after {
        bottom: 10px;
        left: 0px;
        border-width: 0 0 1px 1px
    }

    /***************************************
     Selects
    ****************************************/

    .header-select .vs__search::placeholder,
    .header-select .vs__dropdown-toggle,
    .header-select .vs__dropdown-menu {
        background: #223C46;
        border: none;
        color: #394066;
        text-transform: lowercase;
        font-variant: small-caps;
        min-height: 50px;
        border-radius: unset !important;
    }

    .header-select .vs__clear,
    .header-select .vs__open-indicator {
        fill: #58BCEB;
    }

    .table-select .vs__search::placeholder,
    .table-select .vs__dropdown-toggle,
    .table-select .vs__dropdown-menu {
        background: #092632;
        border: none;
        color: #394066;
        text-transform: lowercase;
        font-variant: small-caps;
        border-radius: unset !important;
    }

    .table-select .vs__clear,
    .table-select .vs__open-indicator {
        fill: #58BCEB;
    }

    .vs__selected {
        color: #fff !important;
    }

    .vs__dropdown-option {
        line-height: 1.42857143;
        display: block;
        padding: 3px 20px;
        clear: both;
        color: #fff !important;
        white-space: nowrap
    }

    .vs__dropdown-option--highlight {
        background: #061D26 !important;
        color: #fff
    }

    .vs__actions {
        justify-content: flex-end !important;
        padding-right: 10px !important;
    }

    .vs__dropdown-toggle {
        cursor: pointer !important;
    }

    .v-select:not(.vs--open) input[type="search"] {
        height: 0;
    }

    /***************************************
     Number
    ****************************************/

    input[type=number]{
        background-color: #092632;
        color: #fff;
        border: none;
        outline: none;
    }

    /***************************************
     Tooltip
    ****************************************/

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

    .tooltip .tooltip-inner {
        background: white;
        color: black;
        padding: 5px 10px 4px;
        max-width: 130px;
        font-family: 'Blender-Pro';
    }

    .tooltip .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: white;
        z-index: 1;
    }

    .tooltip[x-placement^="top"] {
        margin-bottom: 5px;
    }

    .tooltip[x-placement^="top"] .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="bottom"] {
        margin-top: 5px;
    }

    .tooltip[x-placement^="bottom"] .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip.popover .popover-inner {
        background: #f9f9f9;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
    }

    .tooltip.popover .popover-arrow {
        border-color: #f9f9f9;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }


    @media (max-width:1023px) {
        #calculator > .table-container {
            overflow-x: auto;
        }
    }

    @media (max-width:710px) {
        #calculator {
            padding: 30px 20px;
        }
        #calculator .application-setup {
            flex-direction: column;
        }
        #calculator .application-setup div.left {
            width: 100%;
            padding-right: 0;
            padding-bottom: 10px;
        }
        #calculator .application-setup div.right {
            width: 100%;
        }
    }

    @media (max-width:480px) {
        #calculator .doosan-recommends {
            padding: 30px 20px;
        }
        #calculator .doosan-recommends .recommends-2 {
            padding-left: 25px;
            padding-right: 25px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue